export default {
  get: {
    '/accessKey/mock-id': {
      // TBD
    },
    '/accessKey': [
      // TBD
    ],
  },
};
